import { SmartReportComponentTypesEnum, SmartReportTypeEnum } from '@/admins/SmartReports/types';
import {
  Addchart as AddChartIcon,
  Image as ImageIcon,
  TableRows as TableRowsIcon,
  TextFields as TextFieldsIcon,
  TextFormat as TextFormatIcon,
} from '@mui/icons-material';

import { TableFallbackIcon } from '@/admins/SmartReports/components/Icons/TableFallbackIcon';
import { SmartReportEntityTypeEnum } from '@/types/GraphqlSchema';

export const PER_PAGE_OPTIONS: number[] = [10, 25, 50];

export const ORDER_BY_OPTIONS: { value: string; label: string }[] = [
  { value: 'createdAt', label: 'Date created' },
  { value: 'name', label: 'Name' },
  { value: 'status', label: 'Status' },
  { value: 'type', label: 'Type' },
];

export const ORDER_OPTIONS: { value: string; label: string }[] = [
  { value: 'desc', label: 'DESC' },
  { value: 'asc', label: 'ASC' },
];

export const ENTITY_TYPE_BY_REPORT_TYPE: Record<SmartReportTypeEnum, SmartReportEntityTypeEnum> = {
  [SmartReportTypeEnum.Asset]: SmartReportEntityTypeEnum.Asset,
  [SmartReportTypeEnum.Country]: SmartReportEntityTypeEnum.CountryArea,
  [SmartReportTypeEnum.Corporate]: SmartReportEntityTypeEnum.Company,
};

export const COMPONENT_TYPES_ICONS: Record<SmartReportComponentTypesEnum, typeof AddChartIcon> = {
  [SmartReportComponentTypesEnum.Chart]: AddChartIcon,
  [SmartReportComponentTypesEnum.Table]: TableRowsIcon,
  [SmartReportComponentTypesEnum.Image]: ImageIcon,
  [SmartReportComponentTypesEnum.TextArea]: TextFormatIcon,
  [SmartReportComponentTypesEnum.TextField]: TextFieldsIcon,
};

export const COMPONENT_TYPE_FALLBACK_THUMBNAIL: Record<
  SmartReportComponentTypesEnum,
  React.ComponentType
> = {
  [SmartReportComponentTypesEnum.Chart]: AddChartIcon,
  [SmartReportComponentTypesEnum.Table]: TableFallbackIcon,
  [SmartReportComponentTypesEnum.Image]: ImageIcon,
  [SmartReportComponentTypesEnum.TextArea]: TextFormatIcon,
  [SmartReportComponentTypesEnum.TextField]: TextFieldsIcon,
};
